export default __webpack_public_path__ + "static/principal-artists1-a2c6285d2e3f44652e01133f3b9abc2d.jpg";